export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/greenInfo.ef4e9950.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};